import { useCallback, useMemo } from 'react';

import { CrossSIcon, CrossMIcon } from 'assets/icons';

export const useAttentionCardPresenter = ({ direction, onClick }) => {
  const closeIcon = useMemo(() => {
    return direction === 'row' ? CrossMIcon : CrossSIcon;
  }, [direction]);

  const onHandleClose = useCallback(() => {
    onClick();
  }, []);

  return {
    closeIcon,
    onHandleClose,
  };
};
